import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/facturacion/facturaFarmFEL';
import Facturas from './FacturaServiciosTabs';


const ms2p = (state) => {
  return {
    ...state.factura_farm_fel,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Facturas);